const ApiErrorTypes = {
  FILE_MOVE_CONFLICT: 'FILE_MOVE_CONFLICT'
};
export default ApiErrorTypes;